import React, {Fragment} from 'react'
import style from '../scss/components/HeroSeller.module.scss'
import Button from './Button'
import { Fade } from "react-awesome-reveal"
import {useSelector} from 'react-redux'
import giftImg from '../assets/gift-animated.png'

const HeroSeller = () => {
    // @ts-ignore
    const width = useSelector(state => state.window.width)

    return (
        <Fade triggerOnce={true}>
            <div className={style.Wrapper}>
                {width > 950 ? (
                    <Fragment>
                        <div className={style.PracticalGuy}/>
                        <div className={style.PointingArrow}/>
                    </Fragment>
                ) : null}
                <div className={style.InnerWrapper}>
                    <img src={giftImg} width={150} height={150} alt={''}/>
                    <h2>
                        Veel vaid piiratud aeg<br/>
                        <strong>-80% soodustus</strong>
                    </h2>
                    <Button inverted wide onClick={() => window.location.href = '#offer'}>
                        Osta veebikursus vaid 75€ eest siit!
                    </Button>
                    <s>Koolituse tavahind: 375€</s>
                </div>
            </div>
        </Fade>
    )
}

export default HeroSeller
